"use strict";import{Accordion as o}from"./src/Accordion.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-accordion",o);
//# sourceMappingURL=sp-accordion.js.map
